require([
  "share",
  "pym",
  "jquery",
  "sidebar",
  "prints",
  "wax-resist-head",
  "wax-resist",
  "comments/package",
  "lightbox"
], function(Share, pym, $) {

  new Share(".share", {
    ui: {
      flyout: "bottom left"
    }
  });

  var qsa = function(s) { return Array.prototype.slice.call(document.querySelectorAll(s)) };

  //auto-load Pym elements
  qsa("[data-pym]").forEach(function(embed) {
    var id = embed.id;
    new pym.Parent(id, embed.getAttribute("data-pym"));
  });

  //css triggers
  var body = $(document.body);
  body.addClass("ready");
  var isMobile = window.matchMedia && window.matchMedia("(max-width: 480px)").matches;
  if (isMobile) {
    body.addClass("mobile");
  }
  try {
    document.createEvent("TouchEvent");
    body.addClass("touchscreen");
  } catch (e) { /* no touchscreen if exception */ }
  
  //video playback UI
  $(".video-container").each(function() {
    var $container = $(this);
    var video = this.querySelector("video");
    //utility play/pause function
    var toggle = function() {
      if (video.paused) {
        video.play();
        $container.addClass("playing");
      } else {
        video.pause();
        $container.removeClass("playing");
      }
    };
    //handle UI updates
    video.addEventListener("timeupdate", function() {
      if (video.currentTime) {
        $container.removeClass("at-start");
      }
    });
    $container.on("click", function(e) {
      if (e.target.className.indexOf("reset") > -1) {
        video.currentTime = 0;
        $container.addClass("at-start");
      } else {
        toggle();
      }
    });
  });

  //kill videos for iOS 7, the IE6 of mobile, which can't play HD clips in-browser
  if (navigator.userAgent.match(/(iphone|ipad).*OS 7_/i)) {
    var disclaimer = "<span class=warning>Sorry, this animation cannot be played on your device.</span>";
    $(".video-container").addClass("disabled").append(disclaimer)
    //we can remove the sources, but who knows.
    //.find("source").remove();
  }
  
  //load deferred images
  $("img[defer]").each(function() {
    var url = this.getAttribute("data-src");
    this.src = url;
    this.removeAttribute("data-src");
    this.removeAttribute("defer");
  });

}, null, true); //force sync loading;
define("main", function(){});

